<template>
    <div class="space-card">
      <router-link
        :to="`/monitoring/sector`"
        @click.native="cardClickHandler"
      >
        <div
          :class="`monitCard ${bgClassStatus} ${
            isSelected ? 'activeCard' : ''
          }`"
        >
          <div class="top w-100 wrapper-percentage overflow-hidden">
            <div :class="`h-100 ${item.STATUS_COLOR}`" :style="`width: ${loadingProgress}%;`"></div>
          </div>
          <div class="monit-name">
            {{ item.NAME }}
          </div>
          <div>
            <div>
              <sector-icon class="card-icon" />
                Área: {{ item.AREA }} ha
            </div>
            <div>
              <sector-icon class="card-icon" />
              Variedade: {{ item.FARM && item.FARM.NAME }}
            </div>
            <div v-if="!isInactive">
              <div>
                Água inicial disponível:
                {{ item.MANAGEMENT.INITIAL_STORAGE }}mm ({{
                  calcPercentageRounded(
                    item.MANAGEMENT.INITIAL_STORAGE,
                    item.MANAGEMENT.MAX_STORAGE
                  )
                }}%)
              </div>
              <div>
                Água final prevista:
                {{ item.MANAGEMENT.FINAL_STORAGE }}mm ({{
                  calcPercentageRounded(
                    item.MANAGEMENT.FINAL_STORAGE,
                    item.MANAGEMENT.MAX_STORAGE
                  )
                }}%)
              </div>
              <div>
                Excedente previsto:
                {{ item.MANAGEMENT.EXCESS && item.MANAGEMENT.EXCESS.toFixed(2) || 0 }}mm
              </div>

            </div>
          </div>

          <footer class="d-flex align-items-center" :class="item.isLoading ? 'justify-content-end' : 'justify-content-between'">
            <div v-if="isInactive && !item.isLoading">
              <div id="aside-info">
                Modificado {{item.inative_days ? 'a' : ''}}: {{ item.inative_days ? `${item.inative_days} dias` : "Hoje" }} por {{item.EDITOR_NAME || '...'}}
              </div>
            </div>
            <div v-else-if="item.MANAGEMENT">
              <div id="aside-info">
                DAP: {{item.MANAGEMENT.ID_DAP|| 0 }}
              </div>
            </div>

            <div v-if="!isInactive && item.STATUS && item.STATUS.length" class="d-flex align-items-center">
              <div v-if="!item.MANAGEMENT.ID_DAP" class="badge-3v3">
                <numeric-zero-outline title="Pré-Plantio" class="" />
              </div>

              <div v-if="item.STATUS.includes('Com Sensor')" class="badge-3v3">
                <wifi-icon title="Possui Sensor de Solo" />
              </div>
              
              <div v-if="item.STATUS.includes('Colhido')" class="badge-3v3">
                <leaf-icon title="Setor Colhido" class="text-success" />
              </div>

              <div v-if="item.STATUS.includes('Excedente')" class="badge-3v3">
                <water-icon title="Há Excedente Previsto" class="water-icon-excess" />
              </div>
            </div>

            <div class="d-flex align-items-center justify-content-end justify-content-md-center">
              <div :class="`status ${item.STATUS_COLOR }`">
                {{ item.STATUS ? item.STATUS[0] : "Indefinido"  }}
              </div>
            </div>
          </footer>
        </div>
      </router-link>
    </div>
</template>

<script>
import {
  calcPercentageRounded,
} from "@/pages/components/helpers";

import moment from "moment"; 

export default {
  methods: {
    calcPercentageRounded,
    moment,
  },
  computed: {
    isInactive() {
      return !this.item.MANAGEMENT;
    }
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    loadingProgress: {
      type: Number,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
    bgClassStatus: {
      type: String,
      required: false,
      default: '',
    },
    cardClickHandler: {
      type: Function,
      required: false,
      default: () => {},
    },
  }
}
</script>

<style scoped>
.wrapper-percentage {
  background-color: #cbcbcb;
}

.water-icon-excess {
  color: #2997a8 !important;
}

.monit-sector-main {
  width: 100%;
  transition: 0.1s;
  overflow-y: auto;
  height: 100%;
  margin: 0;
}
.card-icon {
  color: #9e9e9e;
  font-size: 13px;
}
.measure-info {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.EmptyRequest {
  width: 100%;
  padding: 10px;
  color: Black;
  font-size: 1.1rem;
  text-align: center;
}
.my-class {
  padding: 0;
}
.monitCard {
  min-height: 210px;
}
.filter-model {
  max-height: 180px;
  overflow-y: auto;
  overflow-x: hidden;
}

.badge-3v3 {
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-3v3 * {
  font-size: 20px;
}
</style>
